// extracted by mini-css-extract-plugin
export default {"container":"emptyRoomsList_container__Yz2LA","containerMessage":"emptyRoomsList_containerMessage__YkSIq"};